import { BaseProxy, type ProxyMethods } from '@/proxies/Proxy'

export default class ScanDocumentProxy extends BaseProxy implements ProxyMethods {
  public endpoint = 'scan-document'
}
